// gatsby-browser.js
import Cookies from "js-cookie";

export const onClientEntry = () => {
  // Hantera samtycke vid sidladdning
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      const hasConsent = Cookies.get("analytics-consent") === "true";
      
      if (hasConsent && window.gtag) {
        // Aktivera Google Analytics om användaren gett samtycke
        window.gtag("consent", "update", {
          analytics_storage: "granted"
        });
        console.log("Analytics aktiverad baserat på samtycke");
      } else {
        // Ta bort eventuella cookies om användaren inte gett samtycke
        const hasGACookies = document.cookie.indexOf('_ga=') !== -1;
        if (hasGACookies && !hasConsent) {
          document.cookie = '_ga=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          document.cookie = '_ga_XNRVMGL7MQ=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
      }
    }, 500);
  }
};

export const onRouteUpdate = () => {
  // Kontrollera samtycke vid varje sidnavigation
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    const hasConsent = Cookies.get("analytics-consent") === "true";
    
    // Uppdatera samtycke vid varje sidnavigation
    window.gtag("consent", "update", {
      analytics_storage: hasConsent ? "granted" : "denied"
    });
  }
};